import { Disclaimer, H5, P } from '@vgrubs/components';
import { AmountCell } from './AmountsPanel.styled';

type Props = {
  amount: string;
  title: string;
  subtitle?: string;
  disabled?: boolean;
  onClick?: () => void;
};

/**
 * One figure on the location screen: what it is, what it costs, and a line of
 * detail. Used for the payout configs and the taxes, so the two panels read
 * the same. Lives here rather than in `LocationDetails` because the taxes
 * section imports it too, and that page imports the taxes section back.
 *
 * A cell, not a card: it sits inside an `AmountsPanel`, and cards inside a box
 * are what made the two groups read as one long strip.
 */
export const AmountComponent = ({
  amount,
  title,
  subtitle,
  disabled,
  onClick,
}: Props) => (
  <AmountCell $disabled={disabled} $clickable={!!onClick} onClick={onClick}>
    <div>
      <P $mb="4">{title}:</P>
      <H5 $mb={subtitle ? '4' : '0'}>
        <span>{amount}</span>
      </H5>
      {subtitle && <Disclaimer $m="0">{subtitle}</Disclaimer>}
    </div>
  </AmountCell>
);
